import { Delete, ImageSearchOutlined, Visibility } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/Done';
import {
  CircularProgress,
  Fab,
  IconButton,
  ImageListItem,
  ImageListItemBar,
  ListItemIcon,
} from '@mui/material';
import { capitalize, ImageLoader } from '@prismamedia/one-components';
import classNames from 'classnames';
import { ViewMode } from 'components/MediaInput/MultimediaPlugin/types';
import { format } from 'date-fns';
import fr from 'date-fns/locale/fr';
import { FC, useEffect, useState } from 'react';
import { PUBLISHED_AT_TEXT, UNKNOWN_TEXT } from '../constants';
import { useStyles as useSharedStyles } from '../styles';
import { GridItemCardProps } from '../types';
import { useStyles } from './styles';

export const GridItemCard: FC<GridItemCardProps> = ({
  chip,
  image,
  isBusy = false,
  isDisabled = false,
  isSelected = false,
  onItemClick,
  publicUrl,
  publishDate,
  status,
  text,
  title,
  viewMode = ViewMode.GRID,
  isSuggestionItem,
}) => {
  const [isInnerBusy, setIsInnerBusy] = useState<boolean>(isBusy);
  const showFooterInfos = Boolean(text || status || title);

  const classes = useStyles({
    isDisabled: isDisabled || isBusy,
    isSelected,
    showFooterInfos,
    title,
    viewMode,
  });
  const sharedClasses = useSharedStyles({ isDisabled: isDisabled || isBusy });

  const labelizedPublishedDate = publishDate
    ? format(new Date(publishDate), 'dd/MM/yyyy à HH:mm', { locale: fr })
    : '';

  useEffect(() => {
    !isDisabled && setIsInnerBusy(isBusy);
  }, [isBusy, isDisabled]);

  return (
    <ImageListItem
      className={classNames(
        classes.wrapperCard,
        isSelected && sharedClasses.selectedWrapperCard,
        isSuggestionItem && sharedClasses.shiningCard,
      )}
    >
      <div
        {...(viewMode === ViewMode.GRID && {
          onClick: () => {
            if (image && !isSelected) {
              setIsInnerBusy(true);
            }

            onItemClick();
          },
        })}
      >
        {viewMode === ViewMode.GRID ? (
          isInnerBusy ? (
            <ListItemIcon className={classes.busyIcon}>
              <CircularProgress size={20} />
            </ListItemIcon>
          ) : (
            isSelected && (
              <ListItemIcon className={classes.selectedIcon}>
                <CheckCircleIcon fontSize="small" />
              </ListItemIcon>
            )
          )
        ) : (
          !isDisabled && (
            <Fab
              className={classes.deleteIcon}
              color="primary"
              onClick={() => {
                onItemClick();
              }}
              size="small"
            >
              <Delete />
            </Fab>
          )
        )}

        <ImageLoader
          className={classes.wrapperMedia}
          image={
            <ImageSearchOutlined className={sharedClasses.mediaFallback} />
          }
          src={image}
        />

        {chip && (
          <ImageListItemBar
            title={chip}
            {...(publicUrl && {
              actionIcon: (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(publicUrl);
                  }}
                  className={classes.eyeIcon}
                >
                  <Visibility />
                </IconButton>
              ),
            })}
            classes={{
              root: classes.topBarRoot,
              titleWrap: classes.topBarTitle,
            }}
          />
        )}

        {showFooterInfos && (
          <ImageListItemBar
            title={
              <>
                {capitalize(text || UNKNOWN_TEXT)}{' '}
                {labelizedPublishedDate &&
                  ` - ${
                    status || PUBLISHED_AT_TEXT
                  } ${labelizedPublishedDate}.`}
              </>
            }
            subtitle={capitalize(title || '--')}
            classes={{
              root: classes.rootTileBar,
              subtitle: classes.barSubtitle,
              title: classes.barTitle,
            }}
          />
        )}
      </div>
    </ImageListItem>
  );
};
